/**
 * Copyright (C), 2012-2019, Sichuan Xiaoka Technology Co., Ltd.
 * 工具包js
 * */

export default {
  toast ({text, timeout = 2000}) { // 提示弹窗
    let app = document.getElementById('app')
    let p = document.createElement('p')
    let t = document.createTextNode(text)
    p.appendChild(t)
    app.appendChild(p)
    // p元素的样式
    p.style.backgroundColor = 'rgba(0,0,0,.5)'
    p.style.color = '#fff'
    p.style.fontSize = '12px'
    p.style.textAlign = 'center'
    p.style.maxWidth = '90%'
    p.style.minHeight = '20px'
    p.style.padding = '6px 10px'
    p.style.borderRadius = '4px'
    p.style.display = 'flex'
    p.style.alignItems = 'center'
    p.style.position = 'absolute'
    p.style.top = '360px'
    p.style.transition = 'all .5s'
    p.style.opacity = 0
    app.style.display = 'flex'
    app.style.justifyContent = 'center'
    setTimeout(() => {
      p.style.opacity = 1
    }, 300)
    setTimeout(() => {
      p.style.opacity = 0
      setTimeout(() => {
        // 移除toast，并将app上的属性恢复成默认值
        app.removeChild(p)
        app.style.display = ''
        app.style.justifyContent = ''
      }, 500)
    }, timeout - 500)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js